<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCardHeader>
        <h5>
          <b>{{ this.gameName }}</b>
        </h5>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CRow>
              <CCol sm="12">
                <label v-c-tooltip.hover.click="tooltip.tournamentName"
                  >Tournament Name <infoIcon></infoIcon>
                </label>
                <CInput v-model="tournamentName" type="text" />
              </CCol>
              <!-- <CCol sm="6">
                <label v-c-tooltip.hover.click="tooltip.poolStartDate"
                  >Tournament Start Time <infoIcon></infoIcon>
                </label>
                <CCard v-if="enablepicker">
                  <CCardHeader>
                    <span>{{ this.editstarttime }}</span>
                    <CButton
                      @click="changepicker()"
                      color="success"
                      style="float: right"
                      >change</CButton
                    >
                  </CCardHeader>
                </CCard>
                <VueCtkDateTimePicker v-model="Poolstarttime" v-else />
                <br />
              </CCol> -->
              <!-- <CCol sm="6" style="margin-top: auto">
                <CCard>
                  <CCardHeader>
                    <span style="font-size: 14px; font-weight: bold"
                      >Contest Enabled</span
                    >

                    <input
                      v-model="isContestEnabled"
                      type="checkbox"
                      value="ContestEnabled"
                      style="float: right; width: 113px; height: 22px"
                    />
                  </CCardHeader>
                </CCard>
              </CCol> -->
              <!-- <CCol sm="6" style="margin-top: auto">
                  <CCard>
                    <CCardHeader>
                      <span style="font-size: 14px; font-weight: bold"
                        >Is Android</span
                      >
  
                      <input
                        v-model="isAndroid"
                        type="checkbox"
                        value="isAndroid"
                        style="float: right; width: 113px; height: 22px"
                      />
                    </CCardHeader>
                  </CCard>
                </CCol>
                <CCol sm="6" style="margin-top: auto">
                  <CCard>
                    <CCardHeader>
                      <span style="font-size: 14px; font-weight: bold"
                        >Is IOS</span
                      >
  
                      <input
                        v-model="isIOS"
                        type="checkbox"
                        value="isIOS"
                        style="float: right; width: 113px; height: 22px"
                      />
                    </CCardHeader>
                  </CCard>
                </CCol> -->

              <CCol sm="6">
                <label v-c-tooltip.hover.click="tooltip.MatchStarttime"
                  >Tournament Live Time <infoIcon></infoIcon>
                </label>
                <CCard v-if="matchTimeEnablePicker">
                  <CCardHeader>
                    <span>{{ this.editMatchtime }}</span>
                    <CButton
                      @click="matchTimeChangePicker()"
                      color="success"
                      style="float: right"
                      >change</CButton
                    >
                  </CCardHeader>
                </CCard>
                <VueCtkDateTimePicker v-model="MatchStarttime" v-else />
                <br />
              </CCol>
              <CCol sm="6">
                <label v-c-tooltip.hover.click="tooltip.MatchEndTime"
                  >Tournament End Time <infoIcon></infoIcon>
                </label>
                <CCard v-if="enablepicker">
                  <CCardHeader>
                    <span>{{ this.editendtime }}</span>
                    <CButton
                      @click="changepicker()"
                      color="success"
                      style="float: right"
                      >change</CButton
                    >
                  </CCardHeader>
                </CCard>
                <VueCtkDateTimePicker v-model="PoolEndtime" v-else />
                <br />
              </CCol>
              <!-- <CCol sm="6">
                  <label>Prize</label>
                  <CInput type="number" v-model="price" />
                </CCol> -->

              <!-- <CCol sm="6">
                  <label>Room ID</label>
                  <CInput v-model="roomID" />
                </CCol>
                <CCol sm="6" v-if="this.roomPassword != 'Ludo King'">
                  <label>Room Password</label>
                  <CInput v-model="roomPassword" />
                </CCol> -->
              <CCol sm="6">
                <label v-c-tooltip.hover.click="tooltip.fee"
                  >Tournament Fee <infoIcon></infoIcon
                ></label>
                <CInput v-model.number="rageEntrancePrice" type="number" />
              </CCol>
              <CCol v-if="userRole != null && userRole != 'user'" sm="6">
                <label>Tournament Extra Fee</label>
                <CInput v-model.number="PrageEntrancePrice" type="number" />
              </CCol>
              <CCol v-if="userRole != null && userRole != 'user'" sm="6">
                <label>Minimum Players</label>
                <CInput v-model.number="minimumPlayers" type="number" />
              </CCol>
              <CCol sm="6">
                <label v-c-tooltip.hover.click="tooltip.maximumPlayers"
                  >Maximum Players <infoIcon></infoIcon
                ></label>
                <CInput v-model.number="maximumPlayers" type="number" />
              </CCol>

              <!-- <CCol v-if="user.userRole != null && userRole == 'user'" sm="6">
                <label>Platform Fee</label>
                <CInput v-model.number="platformFee" type="number" />
              </CCol> -->
              <!-- <CCol sm="12">
                  <CCard>
                    <CCardHeader>
                      <CRow>
                        <CCol sm="3"><h5>Choose Field Type</h5> </CCol>
                        <CCol sm="5">
                          <input
                            type="radio"
                            style="width: 57px; height: 21px"
                            v-model="fieldtype"
                            value="RoomIDandPassword"
                          />&nbsp;<span style="font-size: 17px; font-weight: 500"
                            >RoomID and Password
                          </span>
                        </CCol>
                        <CCol sm="4">
                          <input
                            type="radio"
                            v-model="fieldtype"
                            value="RoomID"
                            style="width: 57px; height: 21px"
                          />&nbsp;<span style="font-size: 17px; font-weight: 500"
                            >RoomID</span
                          >
                        </CCol>
                      </CRow>
                    </CCardHeader>
                  </CCard>
                </CCol> -->

              <CCol sm="6">
                <label v-c-tooltip.hover.click="tooltip.platformFee"
                  >PlatFrom Fee <infoIcon></infoIcon
                ></label>
                <CInput
                  v-model.number="platformFee"
                  :disabled="userRole != null && userRole == 'user'"
                  type="number"
                />
              </CCol>
              <CCol v-if="userRole != null && userRole == 'user'" sm="6">
                <label v-c-tooltip.hover.click="tooltip.creatorFee"
                  >Creator Fee <infoIcon></infoIcon
                ></label>
                <CInput v-model.number="creatorFee" type="number" disabled />
              </CCol>
              <CCol v-if="userRole != null && userRole != 'user'" sm="6">
                <label>TopUp Fee </label>
                <CInput
                  :disabled="userRole != null && userRole == 'user'"
                  v-model.number="topupFee"
                  type="number"
                />
              </CCol>

              <CCol sm="6">
                <label>Select Token </label>
                <Vselect :options="options" v-model="tournamentTokenName" />
                <!-- <CInput v-model="tournamentTokenName" type="text" /> -->
              </CCol>
              <!-- <CCol sm="6">
                <label>Choose a Network</label>
                <Vselect :options="networks" v-model="selectedNetwork" />
              </CCol> -->
              <CCol sm="12" class="mt-3">
                <label v-c-tooltip.hover.click="tooltip.rules"
                  >Add Tournament Rules <infoIcon></infoIcon
                ></label>
                <div
                  class="form-group"
                  v-for="(input, k) in this.rules"
                  :key="k"
                >
                  <CRow>
                    <CCol sm="6">
                      <!-- <label>Rage Fees</label> -->
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Rule...."
                        v-model.number="rules[k]"
                      />
                    </CCol>
                    <CCol sm="2">
                      <span>
                        <CButton
                          color="danger"
                          @click="removeRules(k)"
                          v-show="k || (!k && rules.length > 1)"
                        >
                          <i class="fa fa-times"></i
                        ></CButton>
                        &nbsp;&nbsp;&nbsp;
                        <CButton
                          color="success"
                          @click="addRules()"
                          v-show="k == rules.length - 1"
                        >
                          <i class="fa fa-plus" aria-hidden="true"></i
                        ></CButton>
                      </span>
                    </CCol>
                  </CRow>
                </div>
              </CCol>
              <CCol sm="12">
                <label v-c-tooltip.hover.click="tooltip.distribution"
                  >Pool distribution ({{ this.displayFee }}%)
                  <infoIcon></infoIcon>
                </label>
                <div
                  class="form-group"
                  v-for="(input, k) in this.gamePrize"
                  :key="k"
                >
                  <CRow>
                    <CCol sm="6">
                      <input
                        type="number"
                        class="form-control"
                        placeholder="Game Prize"
                        v-model.number="gamePrize[k]"
                      />
                    </CCol>
                    <CCol sm="2">
                      <span>
                        <CButton
                          color="danger"
                          @click="removeGamePrize(k)"
                          v-show="k || (!k && gamePrize.length > 1)"
                        >
                          <i class="fa fa-times"></i
                        ></CButton>
                        &nbsp;&nbsp;&nbsp;
                        <CButton
                          color="success"
                          @click="addGamePrize()"
                          v-show="k == gamePrize.length - 1"
                        >
                          <i class="fa fa-plus" aria-hidden="true"></i
                        ></CButton>
                      </span>
                    </CCol>
                  </CRow>
                </div>
              </CCol>

              <!-- <CCol sm="6"> </CCol> -->
              <!-- <br /> -->
              <CCol sm="6">
                <label v-c-tooltip.hover.click="tooltip.rewardDistribution"
                  >Reward Distribution Message <infoIcon></infoIcon
                ></label>
                <CTextarea
                  placeholder="Enter Reward Distribution Message here..."
                  horizontal
                  rows="5"
                  class="w-100"
                  v-model="rewardDistributionmsg"
                />
              </CCol>
              <br />
              <CCol sm="6">
                <label v-c-tooltip.hover.click="tooltip.winnersmsg"
                  >Winner Message <infoIcon></infoIcon
                ></label>
                <CTextarea
                  placeholder="Enter Winner Message here..."
                  horizontal
                  rows="5"
                  class="w-100"
                  v-model="winnersmsg"
                />
              </CCol>
              <br />
              <CCol sm="12" style="text-align: center !important">
                <br /><br />
                <CButton
                  color="success"
                  style="width: 20%"
                  :disabled="isActive"
                  @click="saveGame()"
                  >Save</CButton
                >
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>
  
  <script>
import firebase from "firebase";
const db = firebase.firestore();
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import infoIcon from "./info-icon.vue";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import { Vselect } from "@/components";
import { APIService } from "../../apiservice";
export default {
  components: { VueCtkDateTimePicker, Vselect, infoIcon },
  data() {
    return {
      countmatchId: 1,
      isContestEnabled: true,
      isActive: false,
      GameName: "",
      Limit: 0,
      Poolstarttime: "",
      PoolEndtime: "",
      MatchStarttime: "",
      price: 0,
      roomPassword: "",
      roomID: "",
      id: "",
      enablepicker: false,
      editstarttime: "",
      editendtime: "",
      editMatchtime: "",
      matchTimeEnablePicker: false,
      isPoolUpdate: false,
      isMatchUpdate: false,
      options: [],
      networks: [],
      selectedNetwork: "polygon",
      rageEntrancePrice: 0,
      PrageEntrancePrice: 0,
      gamePrize: [0],
      infoEnableTime: "",
      fieldtype: "",
      isfield: true,
      basePoint: "",
      contractAddress: "",
      fee: "",
      icon: "",
      increment: "",
      name: "",
      tournamentExtraFee: "",
      tournamentFee: "",

      PragebasePoint: "",
      contractAddress: "",
      fee: "",
      icon: "",
      increment: "",
      name: "",
      tournamentExtraFee: "",
      tournamentFee: "",
      tokens: null,
      tournamentTokenName: "",
      gameName: "",
      minimumPlayers: 0,
      maximumPlayers: "",
      platformFee: 0,
      topupFee: 0,
      displayFee: null,
      rules: [""],
      tournamentName: "",
      gameImage: "",
      gameId: "",
      rewardDistributionmsg: "",
      gameTokens: [],
      winnersmsg: "",
      creatorFee: 0,
      user: null,
      userRole: null,
      tooltip: {
        tournamentName: " Set a name for your Tournament.",
        poolStartDate:
          "Set Date & Time of when you want your Tournament to be listed under “Upcoming Tournaments”. Must be within 3 days from today’s date.",
        MatchStarttime:
          "Set Date & Time of when you want your Tournament  to go LIVE. Must be within 3 days from today’s date.",
        MatchEndTime:
          "A Live tournament will only happen for 6 hrs from the set “Tournament Live Time”.",
        fee: "Set Entry Fee for your Tournament",
        maximumPlayers:
          "Enter maximum player participation for your tournament.",
        platformFee: "5% fixed platform fee for user created tournaments",
        creatorFee:
          "You will receive 15% from the total collected fee for creating the tournament.",
        rules: "Add Additional Information regarding your tournament",
        distribution:
          "Enter Percentage distribution for every Rank. Eg: 2 winners - 50% for #1 and 30% for #2",
        rewardDistribution: "Enter a message you want to show to users.",
        winnersmsg:
          "Enter a message which will be published in the leaderboard table.",
      },
      // isAndroid: false,
      // isIOS: false,
    };
  },
  watch: {
    platformFee() {
      if (this.platformFee >= 100) {
        this.showMessage("Platform Fee Should be Less Than 100", "warning");
      } else {
        this.displayFee = 100 - (this.platformFee + this.creatorFee);
      }
    },
  },
  methods: {
    addGamePrize() {
      this.gamePrize.push(0);
    },
    removeRules(index) {
      this.rules.splice(index, 1);
    },
    addRules() {
      this.rules.push("");
    },
    removeGamePrize(index) {
      this.gamePrize.splice(index, 1);
    },
    async getUserDetails() {
      try {
        this.user = await APIService.getUserData(
          firebase.auth().currentUser.email
        );
        // console.log("users", this.user);
        if (this.user != null) {
          this.userRole =
            this.user.userRole == undefined ? "user" : this.user.userRole;
          if (this.userRole == "user") {
            this.count();
          }

          this.GetgameName();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async GetgameName() {
      try {
        await db
          .collection("htmlGamesTokens")
          .where("chainless", "==", true)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              this.gameTokens.push(doc.data());
              this.options.push(doc.data().name);
              if (!this.networks.includes(doc.data().network)) {
                this.networks.push(doc.data().network);
              }
            });
          });
      } catch (error) {
        console.log("error", error);
      }
    },
    showMessage(msg, icon) {
      Swal.fire({
        position: "center",
        icon: icon,
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },

    changepicker() {
      this.enablepicker = false;
      this.isPoolUpdate = true;
      this.Poolstarttime = "";
      this.PoolEndtime = "";
    },
    matchTimeChangePicker() {
      this.matchTimeEnablePicker = false;
      this.isMatchUpdate = true;
      this.MatchStarttime = "";
    },
    async saveGame() {
      // console.log("gameName", this.isAndroid, this.isIOS);
      // console.log("tjosdsd", this.topupFee);
      let sum = 0;

      let tokenIcon = this.gameTokens.find(
        (e) => e.name == this.tournamentTokenName
      );
      //  console.log("tokenIcon",tokenIcon)
      for (let i = 0; i < this.gamePrize.length; i++) {
        if (this.gamePrize[i] == 0) {
          this.showMessage("pool percentage should not be zero ", "warning");
          return false;
        } else {
          sum += this.gamePrize[i];
        }
      }

      if (this.gamePrize.length <= 0) {
        this.showMessage("please fill pool percentage", "warning");
      }
      //  else if (this.Poolstarttime == "") {
      //   this.showMessage("Choose Pool Start Time", "warning");
      // } 
      else if (this.MatchStarttime == "") {
        this.showMessage("Choose Match Start Time", "warning");
      } else if (this.PoolEndtime == "") {
        this.showMessage("Choose Match End Time", "warning");
      } else if (this.rageEntrancePrice == "") {
        this.showMessage("Enter Tournament Fee", "warning");
      } else if (this.userRole != "user" && this.PrageEntrancePrice == "") {
        this.showMessage("Enter Tournament Extra Fee", "warning");
      } else if (this.userRole != "user" && this.minimumPlayers === "") {
        this.showMessage("Enter Minimum Players", "warning");
      } else if (this.maximumPlayers == "") {
        this.showMessage("Enter Maximum Players", "warning");
      } else if (this.platformFee === "") {
        this.showMessage("Enter a valid Fee", "warning");
      } else if (this.topupFee === "") {
        this.showMessage("Enter a valid Topup Fee", "warning");
      } else if (this.tournamentName == "") {
        this.showMessage("Enter Tournament Name", "warning");
      } else if (sum < this.displayFee) {
        this.showMessage(
          "Pool distribution should not be less than " + `${this.displayFee}`,
          "warning"
        );
      } else if (sum > this.displayFee) {
        this.showMessage(
          "Pool distribution should not be greater than " +
            `${this.displayFee}`,
          "warning"
        );
      } else if (this.tournamentTokenName == "") {
        this.showMessage("Choose a Token for tournament", "warning");
      } else if (this.selectedNetwork == "") {
        this.showMessage("Choose a Network for tournament", "warning");
      } else if (this.rules.some((e) => e == "")) {
        this.showMessage(
          "Some Fields are Missing in Tournament Rules",
          "warning"
        );
      } else if (this.rewardDistributionmsg == "") {
        this.showMessage("Reward Distribution Message is Required", "warning");
      } else if (this.winnersmsg == "") {
        this.showMessage("Winner Message is Required", "warning");
      } else {
        let maxAmount = this.maximumPlayers * this.rageEntrancePrice;
        let maxPercent = Math.max(...this.gamePrize);
        let maxWinnings = (maxAmount / 100) * maxPercent;
        // this.isActive = true;

        let data = {
          GameId: this.id,
          GameName: this.gameName,
          startTime: this.MatchStarttime,
          endTime: this.PoolEndtime,
          extrapayTime: this.MatchStarttime,
          isContestEnabled: this.isContestEnabled,
          // tournamentId: this.countmatchId,
          tournamentTokenName: tokenIcon.symbol,
          addRage: this.gamePrize,
          platformFee: this.platformFee,
          topupFee: this.topupFee,
          tournamentFee: this.rageEntrancePrice,
          tournamentExtraFee:
            this.userRole == "user"
              ? this.rageEntrancePrice
              : this.PrageEntrancePrice,
          rules: this.rules,
          network: this.selectedNetwork,
          gameImage: this.gameImage,
          minimumPlayers: this.userRole == "user" ? 0 : this.minimumPlayers,
          maximumPlayers: this.maximumPlayers,
          tournamentName: this.tournamentName,
          maxWinnings: maxWinnings,
          tokenImage: tokenIcon.icon,
          rewardDistributionmsg: this.rewardDistributionmsg,
          winnersmsg: this.winnersmsg,
          isFree: false,
          creatorFee: this.creatorFee,
          isUser: this.userRole == "user" ? true : false,
          uId: this.user.uid,
          email: this.user.email,
          // isAndroid: this.isAndroid,
          // isIOS: this.isIOS,
        };
        // if (this.userRole != "user") {
        //   data.minimumPlayers = this.minimumPlayers;
        //   data.maximumPlayers = this.maximumPlayers;
        // }
        console.log("data", data);
        let resp = await axios.post(
          "https://scramble-api.rage.fan/saveTournament",
          // "https://7561-118-185-191-21.ngrok.io/saveTournament",
          // "http://localhost:5000/token-geomine/us-central1/api/saveTournament",
          { ...data }
        );
        console.log("resp", resp);
        // console.log("data", data);
        if (resp.data.status == true) {
          this.showMessage("Saved Successfully", "success");

          this.$router.push({ name: "tournaments" });
        } else {
          this.showMessage(resp.data.Message, "error");

          // this.$router.push({ name: "tournaments" });
        }
      }
    },
    count() {
      db.collection("config")
        .doc("userTournament")
        .get()
        .then((snapshot) => {
          if (snapshot.exists) {
            // console.log("snaascs", snapshot.data());
            this.creatorFee = snapshot.data().creatorFee;
            this.platformFee = snapshot.data().platformFee;
          }

          console.log(" this.creatorFee", this.creatorFee, this.platformFee);
        });
    },
  },
  created() {
    // this.user = JSON.parse(localStorage.getItem("data"));
    this.id = this.$route.params.id;
    this.gameName = this.$route.params.name;
    this.gameImage = this.$route.params.icon;
    this.getUserDetails();
    // console.log("this.gameImage", this.gameImage);
    if (this.gameImage == undefined) {
      window.history.back();
    }
    // console.log("userwsss", this.user);
    // if (this.user.userRole == "user") {
    //   this.count();
    // }
    // // console.log("entered created", this.id,this.gameName);
    // // this.GetDataByID();
    // //   this.count();
    // this.GetgameName();
  },
};
</script>
<style scoped>
label {
  font-weight: 700 !important;
}
</style>
  